module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "panel-heading"
  }, [_vm._t("top"), _vm._v(" "), _vm._t("title", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _vm._c('span', {
    staticClass: "panel-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2342f6ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/panels/Heading.vue
// module id = 633
// module chunks = 1